// components/MyMap.tsx
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { GoogleMap, useLoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { Utils } from 'helpers/utils';

interface MyMapProps {
  headerHeight: number;
  truckHeading: number; // degrees (0=north, 90=east, 180=south, 270=west)
  zoomLevel?: number;
  lat: number;
  lng: number;
  desLat: number;
  desLng: number;

  infoTitle?: string;
  infoLine1?: string;
  infoLine2?: string;
  infoHtml?: string;
}

const MyMap: React.FC<MyMapProps> = ({ headerHeight, truckHeading, lat, lng, infoTitle, infoLine1, infoLine2, infoHtml, desLat, desLng, zoomLevel = 13 }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: 'AIzaSyD-kZF1je7BX593V-iwQyZIU39ud8PUUvo', // Replace with your API key
  });

  const containerStyle = {
    width: '100%',
    height: 'calc(100vh - ' + headerHeight + 'px)',
  };

  // const center = {lat: lat,lng: lng,};

  const [selected, setSelected] = useState<any>({ lat: lat, lng: lng, });
  const [destination, setDestination] = useState<any>({ lat: desLat, lng: desLng, });
  const [showInfoWindow, setShowInfoWindow] = useState<boolean>(true);

  useEffect(() => {
    console.log({ showInfoWindow, selected });
  }, [showInfoWindow, selected]);






  const onClickMap = (event: any) => {
    try {
      // Check if the click was NOT on a marker
      const clickedMarker = event.target;

      if (!clickedMarker || !clickedMarker.getPosition) {
        // Hide the InfoWindow if clicked on blank space or anything that's not a marker
        setShowInfoWindow(false);
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }



  // --- Your SVG generation logic ---
  let svg = '';
  if (truckHeading > 0) {
    svg =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">' +
      '<circle cx="256" cy="256" r="256" fill="red"/>' +
      '<polygon points="256,128 128,256 224,256 224,384 288,384 288,256 384,256" fill="white" transform="rotate(' +
      truckHeading +
      ' 256 256)"/>' +
      '</svg>';
  } else {
    svg =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">' +
      '<circle cx="256" cy="256" r="256" fill="red"/>' +
      '<path fill="white" transform="scale(0.5) translate(256, 256)" d="M0 80c0-26.5 21.5-48 48-48H384c26.5 0 48 21.5 48 48V320H512V192h84.7c12.8 0 24.8 6.1 32.4 16.5l43.7 58.2c4.8 6.4 7.2 14.1 7.2 22V384c0 17.7-14.3 32-32 32h-16c0 35.3-28.7 64-64 64s-64-28.7-64-64H224c0 35.3-28.7 64-64 64s-64-28.7-64-64H48c-26.5 0-48-21.5-48-48V80zm560 304a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM160 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/>' +
      '</svg>';
  }


  const mapRef = useRef<google.maps.Map | null>(null);
  const onLoad = useCallback((map: google.maps.Map) => {
    mapRef.current = map;
    const bounds = new window.google.maps.LatLngBounds();
    bounds.extend(selected);
    bounds.extend(destination);
    // // Extend northward to account for InfoWindow -> not work
    // const northPoint = new google.maps.LatLng(Math.max(selected.lat, destination.lat) + 0.015, selected.lng);
    // bounds.extend(northPoint);

    map.fitBounds(bounds, {
      top: 50,     // Adjust padding depending on where the InfoWindow shows
      bottom: 50,
      left: 50,
      right: 50
    });

    console.log('onLoad:', map);

  }, []);


  if (!Utils.IsValidLatLng(lat, lng)) return <div>Given Latitude and Longtitude is not valid</div>;
  if (loadError) return <div>Error loading map</div>;
  if (!isLoaded) return <div>Loading map...</div>;

  const svgMarker: google.maps.Icon = {
    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
    scaledSize: new window.google.maps.Size(32, 32),
    origin: new window.google.maps.Point(0, 0),
    anchor: new window.google.maps.Point(16, 16),
  };

  return (
    <GoogleMap mapContainerStyle={containerStyle} onLoad={onLoad} center={selected} zoom={zoomLevel} onClick={(e) => onClickMap(e)}  /*onLoad={() => setSelected(selected)}*/>
      <Marker
        position={selected}
        icon={svgMarker}
        onClick={() => setShowInfoWindow(true)} // Track click on your custom marker
      />
      <Marker position={destination} icon={{
        url: "/icons/destination2.png",
        scaledSize: new window.google.maps.Size(50, 50), // width x height
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(16, 16), // center the icon
      }} />
      {showInfoWindow && (
        <InfoWindow
          position={selected}
          onCloseClick={() => setShowInfoWindow(false)}
          options={{
            pixelOffset: new google.maps.Size(0, -18) // move up by 30px
          }}
        >
          {infoHtml ? (
            <div dangerouslySetInnerHTML={{ __html: infoHtml }}>
            </div>
          ) : (
            <>
              <div className='text-black'>
                <h4 className='text-black'>{infoTitle}</h4>
                <p>
                  {infoLine1}<br />{infoLine2}
                </p>
              </div>

            </>
          )}
        </InfoWindow>
      )}
    </GoogleMap>
  );
};

export default MyMap;
